var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiSearchIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 27,
    viewBox: "0 0 27 27",
    width: 27,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    fill: "#b9c6d7",
    r: 13.5
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#434a59",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.201238,
    cy: 5.201238,
    r: 5.201238
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.10216718 9.23219814 3.92493472 3.92493476",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiSearchIconRound);
export default __webpack_public_path__ + "static/media/ui-search-icon-round.8a1304719e811c8f0fe149b562a6dadb.svg";
export { ForwardRef as ReactComponent };